import React from "react";
import Button from "../../form/Button";
import { useSelector } from "react-redux";
import Modal from "../../elements/front/Modal";
import { profileUpdate } from "../../../services/ProfileService";
import { useNavigate } from "react-router-dom";
import { CreateChat } from "../../../services/communicationService";
import ManageProfile from "./ManageProfile";
import defultprofileCover from "../../../assets/image/defultprofileCover.jpg"

const ProfileTotalDetails = ({ user }) => {
  const [isEditOpen, setIsEditOpen] = React.useState(false);
  const [formData, setFormData] = React.useState(user);
  const navigate = useNavigate();
  const { session } = useSelector((state) => state.authProvider);
  const isOwnProfile = session?.user?._id === user?._id;
  const handleSave = async () => {
    try {
      await profileUpdate(formData); // your API
      setIsEditOpen(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleStartChat = async () => {
    const currentUserId = session?.user?._id;
    const receiverId = user?._id;

    if (!currentUserId || !receiverId) return;

    const payload = {
      // ✅ SAME PATTERN AS APPLICATIONS
      organization: user?.organization?._id,

      createdBy: receiverId,
      customerId: currentUserId,

      message: {
        user: currentUserId,
        name: session?.user?.firstName || "User",
        content: "Hi 👋",
      },
    };

    try {
      const res = await CreateChat(payload);

      const chatId = res?.data?.communicationGroupId;

      navigate(`/messages?chatId=${chatId}`);
    } catch (err) {
      console.log(err);
    }
  };
  const { firstName, lastName, email, image, organization, coverMedia } =
    user || {};

  const fullName = `${firstName || ""} ${lastName || ""}`;

  // ✅ Profile Image
  const profileImage = image?.url || "/default-user.png";

  // ✅ Profile Cover Image (NOT org)
  const profileCover = coverMedia?.url || "/default-cover.jpg";

  // ✅ Organization (safe destructure)
  const orgName = organization?.content?.en?.title;
  const orgLogo = organization?.logo?.url?.url;
  const orgAddress = organization?.address?.[0];
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
     
      {/* Cover Image */}
      <div className="relative">
        <img
          src={profileCover || defultprofileCover}
          alt="cover"
          className="w-full h-40 object-cover"
        />

        {/* Profile Image */}
        <div className="absolute -bottom-12 left-6">
          <img
            src={profileImage}
            alt={fullName}
            className="w-28 h-28 rounded-full border-4 border-white object-cover"
          />
        </div>
      </div>

      {/* Info Section */}
      <div className="pt-16 px-6 pb-6">
        <h2 className="text-xl font-semibold text-gray-900">{fullName}</h2>

        <p className="text-sm text-gray-600">{email}</p>

        <p className="text-sm text-gray-500 mt-1">{orgName}</p>

        <p className="text-sm text-gray-500">
          {orgAddress?.city}, {orgAddress?.state}, {orgAddress?.country}
        </p>

        {/* Buttons */}
        <div className="flex gap-3 mt-4">
          {isOwnProfile ? (
            <Button
              buttonLabel="Edit Profile"
              buttonFunction={() => setIsEditOpen(true)}
              buttonClasses="bg-blue-600 text-white px-4 h-9 rounded-full"
            />
          ) : (
            <>
              <Button
                buttonLabel="Connect"
                buttonClasses="bg-blue-600 text-white px-4 h-9 rounded-full"
              />
              <Button
                buttonLabel="Message"
                buttonClasses="border px-4 h-9 rounded-full"
                buttonFunction={() => {
                  handleStartChat();
                }}
              />
            </>
          )}
        </div>
      </div>

      {/* Organization Card */}
      <div className="px-6 pb-6 border-t pt-4">
        <h3 className="text-sm font-semibold text-gray-700 mb-2">Company</h3>

        <div className="flex items-center gap-3">
          <img
            src={organization?.logo?.url?.url}
            alt="org"
            className="w-10 h-10 rounded"
          />
          <div>
            <p className="text-sm font-medium">
              {organization?.content?.en?.title}
            </p>
            <p className="text-xs text-gray-500">
              {organization?.content?.en?.content}
            </p>
          </div>
        </div>
      </div>

      <Modal
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        title="Edit Profile"
        size="lg"
      >
        <ManageProfile user={user} close={() => setIsEditOpen(false)} />
      </Modal>
    </div>
  );
};

export default ProfileTotalDetails;
